const STYLE_ID = 'orca-chat-host-layout-styles';
const HTML_CLASS = 'orca-chat-page-split';
const SPLIT_RIGHT = 'orca-chat-split-right';
const SPLIT_LEFT = 'orca-chat-split-left';

const DEFAULT_HOST_WIDTH_PERCENT = 70;

function hostWidthCss(percent: number): string {
  return `${percent}vw`;
}

function widgetWidthCss(percent: number): string {
  return `${100 - percent}vw`;
}

function ensureHostLayoutStyles(hostWidthPercent: number): void {
  if (document.getElementById(STYLE_ID)) {
    return;
  }

  const hostWidth = hostWidthCss(hostWidthPercent);
  const widgetWidth = widgetWidthCss(hostWidthPercent);
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    html.${HTML_CLASS}.${SPLIT_RIGHT} body {
      width: ${hostWidth} !important;
      max-width: ${hostWidth} !important;
      overflow-x: auto;
      transition: width 0.2s ease, margin 0.2s ease;
    }

    html.${HTML_CLASS}.${SPLIT_LEFT} body {
      width: ${hostWidth} !important;
      max-width: ${hostWidth} !important;
      margin-left: ${widgetWidth} !important;
      overflow-x: auto;
      transition: width 0.2s ease, margin 0.2s ease;
    }

    html.${HTML_CLASS} {
      overflow-x: hidden;
    }
  `;
  document.head.appendChild(style);
}

export function enableHostSplit(
  position: 'bottom-right' | 'bottom-left',
  hostWidthPercent = DEFAULT_HOST_WIDTH_PERCENT,
): void {
  ensureHostLayoutStyles(hostWidthPercent);
  const root = document.documentElement;
  root.classList.add(HTML_CLASS);
  root.classList.toggle(SPLIT_RIGHT, position === 'bottom-right');
  root.classList.toggle(SPLIT_LEFT, position === 'bottom-left');
}

export function disableHostSplit(): void {
  document.documentElement.classList.remove(HTML_CLASS, SPLIT_RIGHT, SPLIT_LEFT);
}

export function removeHostLayoutStyles(): void {
  disableHostSplit();
  document.getElementById(STYLE_ID)?.remove();
}
